module.exports = {
  site: {
    title: 'The Broomwagon',
    subtitle: 'Girona',
    caption: 'best coffee experience on location',

    description:
      'The Broomwagon. World-class coffee on (three) wheels based in Girona. Bring the Broomwagon to your event to provide your guests with an amazing coffee experience on location. Go to our web shop to buy our beautiful kit!',

    url: 'https://www.thebroomwagongirona.com', // Domain of your site. No trailing slash!
    // url: 'https://broomwagongirona.netlify.com', // Domain of your site. No trailing slash!
    pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
    siteLanguage: 'en', // Language Tag on <html> element
    siteLogo: '/images/logo.jpg', // Used for SEO and manifest
  },
  directus_api: {
    // url: `http://localhost`,
    url: 'api.thebroomwagongirona.com',
    protocol: 'http',
    apiKey: 'etIfgwbpyKszCdBPYh7dUsYDyX8oDk3Y',
  },
  google: {
    analyticsID: 'UA-19600184-9',
  },
};



// WEBPACK FOOTER //
// ./settings.js